import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, map, of, switchMap, tap } from 'rxjs';

import { UserInfoService } from '../../auth/user-info/user-info.service';
import { UserInfo } from '../../auth/user-info/user-info.types';

import { getServiceDefinition } from './local-backend';
import { buildIdentityHeader } from './local-backend-headers';
import { LocalBackend } from './local-backend.types';

/**
 * This is to simulate the api-gateway job
 */
export const localBackendInterceptor: (services: LocalBackend[]) => HttpInterceptorFn[] = (
    services: LocalBackend[]
) => [
    (req, next) => {
        const localBackend = getLocalBackend(services, req.url);
        if (!localBackend) {
            return next(req);
        }
        const loggedInUser$ = inject(UserInfoService, { optional: true })?.loggedInUser;
        return ((loggedInUser$ ?? of(undefined)) as Observable<UserInfo | undefined>).pipe(
            map(loggedInUser =>
                loggedInUser
                    ? {
                          'x-identity': buildIdentityHeader({ sub: loggedInUser.userId.toUpperCase() }),
                          ...localBackend.headers
                      }
                    : localBackend.headers
            ),
            tap(headers =>
                console.log(`[LocalBackend] Routing request to ${req.url} to local backend`, localBackend, headers)
            ),
            switchMap(setHeaders => next(req.clone({ setHeaders })))
        );
    }
];

function getLocalBackend(localBackends: LocalBackend[], url: string): LocalBackend | undefined {
    if (url.startsWith('http')) {
        // if it comes after ApiGatewayRoutingInterceptor
        return localBackends.find(b => url.startsWith(b.baseUrl));
    }

    try {
        // if it comes before ApiGatewayRoutingInterceptor
        return getServiceDefinition(url, localBackends);
    } catch {
        return undefined;
    }
}
